import { RISK_GROUPS, RiskKeys } from '@/config';
import { RiskType } from '@/models';

export const emptyLevels = {
  low: undefined,
  medium: undefined,
  high: undefined,
  severe: undefined,
};

export const DEFAULT_EXPANDED_STATE: Record<RiskType, boolean> = {
  trusted: true,
  suspicious: false,
  danger: false,
};

type TransactionAlertsTableGroup = {
  title: string;
  type: RiskType;
  signals: RiskKeys[];
};

export const transactionAlertsTableGroups: TransactionAlertsTableGroup[] = [
  {
    title: 'Trusted sources',
    type: 'trusted',
    signals: RISK_GROUPS.trusted,
  },
  {
    title: 'Suspicious sources',
    type: 'suspicious',
    signals: RISK_GROUPS.suspicious,
  },
  {
    title: 'Danger',
    type: 'danger',
    signals: RISK_GROUPS.danger,
  },
];
